import * as React from "react";

import { SignupNavigationConfig } from "@brexhq/next/sanity-typegen";
import { ModuleThemeType } from "@brexhq/shared/types/ModuleTheme";

import {
  FormSettingsProps,
  LeadFormControllerDataProps,
} from "./LeadformController";

export type LeadFormModuleContextProps = Pick<
  LeadFormControllerDataProps,
  | "leadFormSuccess"
  | "bypassSuccessContentUrl"
  | "customFormTitle"
  | "customSubmitButtonLabel"
  | "customExistingLeadFormTitle"
  | "customExistingLeadSubmitButtonLabel"
  | "customProgramName"
  | "isInlineEmail"
  | "marginTop"
  | "inlineEmailFieldWidth"
  | "checkWorkEmail"
> & {
  theme: ModuleThemeType;
  navigationConfig?: SignupNavigationConfig;
  formSettings?: FormSettingsProps;
};

export const LeadFormModuleContext =
  React.createContext<LeadFormModuleContextProps>(
    {} as LeadFormModuleContextProps,
  );

type LeadFormModuleProviderProps = {
  children: React.ReactNode;
} & LeadFormModuleContextProps;

export const LeadFormModuleProvider = ({
  leadFormSuccess,
  customFormTitle,
  customExistingLeadFormTitle,
  customSubmitButtonLabel,
  customExistingLeadSubmitButtonLabel,
  customProgramName,
  bypassSuccessContentUrl,
  isInlineEmail,
  inlineEmailFieldWidth,
  checkWorkEmail,
  marginTop,
  theme,
  navigationConfig,
  formSettings,
  children,
}: LeadFormModuleProviderProps) => {
  return (
    <LeadFormModuleContext.Provider
      value={{
        customProgramName,
        leadFormSuccess,
        customFormTitle,
        customExistingLeadFormTitle,
        customExistingLeadSubmitButtonLabel,
        customSubmitButtonLabel,
        bypassSuccessContentUrl,
        marginTop,
        isInlineEmail,
        inlineEmailFieldWidth,
        checkWorkEmail,
        theme,
        navigationConfig,
        formSettings,
      }}
    >
      {children}
    </LeadFormModuleContext.Provider>
  );
};

export const useLeadFormModuleContext = () => {
  return React.useContext(LeadFormModuleContext);
};
